import { Avatar, Card, CardBody, CardFooter, CardHeader, CardSubtitle, CardTitle } from '@progress/kendo-react-layout'
import React from 'react'
import { RevUserContext, RevUserContextType } from '../../../context/UserContext'
import { UserApi } from '../../../redux/api/UserApi'
import { useReduxDispatch, useReduxSelector } from '../../../redux/hooks'
import { PartialSpinny } from '../../Nav/Spinny'
import { ContactOptions } from './ContactOptions'


export const ContactCard: React.FC<ContactCardProps> = (props) => {
    const dispatch = useReduxDispatch();
    const { currentIframeSrc } = useReduxSelector(state => state.revI)
    const { profile } = React.useContext<RevUserContextType>(RevUserContext)
    const { data: contact, isFetching } = UserApi.useGetUserByIdQuery(props.id)
    const buttonClass = 'k-button k-button-md k-rounded-md k-button-flat k-button-flat-base contacts-tool-button';

    if (!contact || isFetching)
        return <PartialSpinny />

    const fieldsToRender = props.fieldsCSV.split(",").map(f => {
        const l = props.fieldLabels.find(fl => fl.split(',')[0].toLocaleLowerCase() === f.toLocaleLowerCase())?.split(',')
        let icon = l && l[0] === 'PrimaryEmail' && <div className='k-font-icon k-i-email mr-1'></div>
        icon = icon || (l && l[0] === 'Full_Address' && <div className='k-font-icon k-i-marker-pin mr-1'></div>)

        let text = contact[f]?.replaceAll('<br/>', '\n').toString()
        let display = l[0] === 'PrimaryEmail'
            ? <a className='mail' href={`mailto:${text}`}>{text}</a>
            : text
        display = l[0] === 'Mobile' || l[0] === 'Bus_Phone'
            ? <a className='tel' href={`tel:${text}`}>{text}</a>
            : display

        return contact && contact[f] && (
            <div className='data'><label>{l && l[1]}:</label>{icon}{display}</div>
        )

    })

    return (
        <div className='contact-card'>
            <CardHeader
                className="k-hbox"
                style={{
                    background: "transparent",
                }}
            >
                {profile?.Features.Profile_Images &&
                    <Avatar type="image" size='large'  >
                        <img className='profile-image2'
                            alt={`Profile image for ${contact.FullName}`}
                            src={contact.Profile_Image_Path ? contact.Profile_Image_Path : './images/placeholder.png'}
                        />
                    </Avatar>}

                <div style={{ marginLeft: "10px", }}   >
                    <CardTitle>
                        {contact.FullName}
                    </CardTitle>
                    <CardSubtitle>
                        <p><div>{contact.Company_Name}</div>{contact.Address_Name}</p>
                    </CardSubtitle>
                </div>
            </CardHeader>
            <CardBody className="contact-details">
                {fieldsToRender}
            </CardBody>
            <CardFooter>
                {props.options.map(a => {
                    const iconOrImage = a.icon
                        ? <span className={`k-font-icon ${a.icon}`} />
                        : <img alt={a.title} src={a.image} className={'k-i-plus'} />

                    return (<button className={buttonClass} title={a.title} onClick={() => a.onclick(contact)}>
                        {iconOrImage}
                    </button>)
                })}
            </CardFooter>
        </div>
    )
}

export type ContactCardProps = {
    id: number,
    fieldsCSV: string,
    fieldLabels: string[],
    options: ContactOptions[]
}